// General
import "./coins-discount-dialog.scss";
import { useEffect } from "react";
// Services
import { useLazyGetBannerListQuery } from "../../../../services/data.service";
// Static Data
import routeConst from "../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateCoinsDiscountDialog } from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// Custom Hooks
import useCustomNavigate from "../../../utility/custom-hooks/useCustomNavigate-hook";

const CoinsDiscountDialog = () => {
  // API variables
  const [
    getBannerList,
    {
      data: getBannerListData,
      error: getBannerListErrorData,
      isFetching: getBannerListFetching,
      isLoading: getBannerListLoading,
      isSuccess: getBannerListSuccess,
      isError: getBannerListError,
    },
  ] = useLazyGetBannerListQuery();

  // Redux variables
  const coinsDiscountDialog = useSelector(
    (state) => state.dialog.coinsDiscountDialog
  );
  const dispatch = useDispatch();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!coinsDiscountDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-CoinsDiscount-Dialog",
      },
    });

    getBannerList(`?category=close_stream`, true);
  }, [coinsDiscountDialog]);

  // Event Handlers | Button
  const onOpenCoinShop = () => {
    onNavigate(routeConst.profile.wallet.path);
    onCloseDialog();
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateCoinsDiscountDialog(false));
  };

  if (getBannerListData?.data?.length > 0) {
    return (
      <Dialog
        className="custom-radius35-dialog"
        open={coinsDiscountDialog}
        onClose={onCloseDialog}
      >
        <div id="coins-discount-dialog">
          <div className="dialog-header">
            <div className="close-button-container">
              <CloseIcon className="close-button" onClick={onCloseDialog} />
            </div>
          </div>

          <div className="coins-discount-banner-container">
            <img
              className="coins-discount-banner"
              src={getBannerListData?.data[0]?.asset_url}
            />

            <div className="redirect-button" onClick={onOpenCoinShop}></div>
          </div>
        </div>
      </Dialog>
    );
  }
};

export default CoinsDiscountDialog;
